import _extends from "@babel/runtime/helpers/esm/extends";
import { gridFilterModelSelector, gridSortModelSelector, gridPaginationModelSelector } from '@mui/x-data-grid';
import { createSelector, createSelectorV8 } from '@mui/x-data-grid/internals';
var computeStartEnd = function(paginationModel) {
    var start = paginationModel.page * paginationModel.pageSize;
    var end = start + paginationModel.pageSize - 1;
    return {
        start: start,
        end: end
    };
};
export var gridGetRowsParamsSelector = createSelector(gridFilterModelSelector, gridSortModelSelector, gridPaginationModelSelector, function(filterModel, sortModel, paginationModel) {
    return _extends({
        groupKeys: [],
        paginationModel: paginationModel,
        sortModel: sortModel,
        filterModel: filterModel
    }, computeStartEnd(paginationModel));
});
export var gridDataSourceStateSelector = function(state) {
    return state.dataSource;
};
export var gridDataSourceLoadingSelector = createSelector(gridDataSourceStateSelector, function(dataSource) {
    return dataSource.loading;
});
export var gridDataSourceLoadingIdSelector = createSelectorV8(gridDataSourceStateSelector, function(dataSource, id) {
    var _dataSource_loading_id;
    return (_dataSource_loading_id = dataSource.loading[id]) !== null && _dataSource_loading_id !== void 0 ? _dataSource_loading_id : false;
});
export var gridDataSourceErrorsSelector = createSelector(gridDataSourceStateSelector, function(dataSource) {
    return dataSource.errors;
});
export var gridDataSourceErrorSelector = createSelectorV8(gridDataSourceStateSelector, function(dataSource, id) {
    return dataSource.errors[id];
});
